import { useContext } from 'react';

import { BigBuyBarDesktopViewStateContext } from 'productTemplate/providers/BigBuyBarDesktopViewStateProvider';

export const useBigBuyBarDesktopView = () => useContext(BigBuyBarDesktopViewStateContext);
